<template>
  <div class="input-wrapper">
    <div class="input">
      <div v-if="label" class="input__label">{{ label }}</div>
      <label class="input__field">
        <input
          :id="name"
          ref="input"
          v-model="value"
          :name="name"
          :type="type"
          :autocomplete="autocomplete"
          :placeholder="placeholder"
          :class="{ _error: error }"
          @input="input?.focus()"
        />

        <p
          ref="error"
          class="input__error"
          :style="{
            maxHeight: `${errorHeight}px`,
          }"
          v-html="error"
        />
      </label>
    </div>
    <div
      class="input-append-content"
      :style="{
        bottom: error && `${errorHeight / 2}px`,
      }"
    >
      <slot />
    </div>
  </div>
</template>

<script setup>
const value = defineModel({
  type: String,
  default: '',
});
const props = defineProps({
  label: {
    type: String,
    default: null,
  },
  type: {
    type: String,
    default: 'text',
  },
  placeholder: {
    type: String,
    default: '',
  },
  name: {
    type: String,
    default: '',
  },
  error: {
    type: String,
    default: null,
  },
  autocomplete: {
    type: String,
    default: null,
  },
});

const input = useTemplateRef('input');
const errorRef = useTemplateRef('error');

const errorHeight = ref(0);

watch(
  () => props.error,
  (errorText) => {
    nextTick(() => {
      errorHeight.value = errorText ? errorRef?.value?.scrollHeight : 0;
    });
  },
);
</script>

<style lang="scss">
@use '@styles/components/ui/input.scss' as *;
</style>
